import { useItem } from '@api/generics';
import QueryKeys from '@api/index';
import API_ROUTES from '@api/routes';
import Loader from '@components/Loader/Loader';
import React, { FC } from 'react';
import { IWizard, WizardMode } from 'types/wizard';
import HomeHeader from './HomeHeader';

const HomeHeaderSkeleton: FC = () => {
	const { data, isLoading } = useItem<IWizard>(
		QueryKeys.wizard,
		API_ROUTES.v1.wizard.update
	);

	if (data && data.mode === WizardMode.dismissed) {
		return null;
	}

	return (
		<Loader isLoading={isLoading} variant="header">
			{data && <HomeHeader state={data} />}
		</Loader>
	);
};

export default HomeHeaderSkeleton;
